<template>

	<div>
		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Existing Schemas</h4>
			</div>
			<div class="card-body">

				Here is a full list of Schemas. The next release will have a full Schema search and browser:

				<!-- <ul class="list-unstyled mt-3 mb-4">
					<li v-for="( schema, index ) in schemaList" :key="index">
						<router-link :to="'/nodes/'+ nodeId +'/projects/'+ projectId +'/schemas/'+ schema.$id.split(':')[1] ">{{schema.$id.split(':')[1]}}</router-link>
					</li>
				</ul> -->
				<ul class="pl-0">
					<tree-node v-for="( node, index ) in getSchemaNodeTree( )" :key="`snt_${index}`" :node="node" />
				</ul>
				<button class="btn btn-primary" @click.prevent="loadSchemas( true )"><i class="fas fa-sync-alt"></i> Refresh</button>
				<button class="btn btn-primary" title="Download Fully Formatted JSON (ordered keys)" @click.prevent="downloadSchemasData( true )"><i class="fas fa-download"></i> Formatted</button>
				<button class="btn btn-primary" title="Download Compact (unformatted) JSON (ordered keys)" @click.prevent="downloadSchemasData( false )"><i class="fas fa-download"></i> Compact</button>
			</div>
		</div>

		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Create New Schema</h4>
			</div>
			<div class="card-body px-3">
				<div class="form-group">
					<label for="newSchema_parent">Derived Schema</label>
					<select v-model="newSchemaParent" class="form-control" id="newSchema_parent" aria-describedby="newSchema_parentHelp">
						<option value="" class="font-italic text-muted">NONE (Root Schema)</option>
						<option :value="schema.$id.split(':')[1]" v-for="( schema, index ) in schemaList" :key="index" :title="schema.description">{{schema.$id.split(':')[1]}}</option>
					</select>
					<small id="newSchema_parentHelp" class="form-text text-muted">Select the parent schema to be extended. Or "Nothing" to create a root schema.</small>
				</div>
				<div class="form-group">
					<label for="newSchema_id">Name</label>
					<input ref="schemaNewName" v-model="newSchemaName" type="text" class="form-control" :class="{ 'is-invalid' : schemaNameError }" id="newSchema_name" aria-describedby="newSchema_name" placeholder="Enter name">
					<div class="alert alert-danger" role="alert" :class="{'d-none':!schemaNameError}">
						The schema name may only contain alphanumeric characters, underscores and single dashes inbetween other characters.
					</div>
					<small id="newSchema_nameHelp" class="form-text text-muted">Name of this Schema (e.g. product, build-material, toy)</small>
				</div>
				<div class="form-group">
					<label for="newSchema_desc">Description</label>
					<textarea v-model="newSchema.description" type="text" class="form-control" id="newSchema_desc" aria-describedby="newSchema_descHelp" placeholder="Enter description" rows="2"></textarea>
					<small id="newSchema_descHelp" class="form-text text-muted">Descriptive details (e.g. "This is a testing schema")</small>
				</div>
				<div class="form-check mb-3">
					<input v-model="newSchema.abstract" type="checkbox" class="form-check-input" id="newSchema_abstract">
					<label class="form-check-label" for="newSchema_abstract">Abstract <small class="text-muted">(objects based on this exact schema will not be considered valid)</small></label>
				</div>

				<div class="alert alert-warning" role="alert">
					<strong>Notice:</strong> Fields can be added, once the schema entry is created.
					<br>
					<small>This is a temporary limitation.</small>
				</div>

				<!-- <h4 class="my-2 font-weight-normal">Standard Fields</h4>
				<div class="container p-0" style="padding-right: 50px !important;" ref="schemaFields">
					<schema-editor-field v-for="(field,index) in standardFields" :key="index" :field="field" :source="standardFields" :index="index" :schemas="schemaLookup" />
					<button @click.prevent="addSchemaField( )" class="btn btn-info mt-1">Add Field to Schema</button>
				</div>

				<template v-if="newSchemaParent">
					<h4 class="my-2 font-weight-normal">Derived Field Overrides</h4>
					<div class="container p-0" style="padding-right: 50px !important;">
						<schema-derived-field v-for="(field,index) in parentCompiledFields" :key="field.$id" :field="field" :override="overrideFields[field.$id]" :override-lookup="overrideFields" :index="index" :schemas="schemaLookup" :schema="newSchema" :source="parentCompiledFields" />
					</div>
				</template> -->

				<hr>
				<div class="form-group mb-0 mt-2">
					<button class="btn btn-success" @click.prevent="createSchemaFromData"><i class="fas fa-star"></i> Create {{(newSchemaParent ? "Derived" : "Root")}} Schema</button>
					<div class="form-check-inline mt-2 ml-2">
						<input type="checkbox" v-model="doNotNavigateToNewSchema" class="form-check-input mt-0" id="f_doNotNavigateToNewSchema">
						<label class="form-check-label" for="f_doNotNavigateToNewSchema">Stay on this page after creation <small class="text-muted">(otherwise, navigates to new schema)</small></label>
					</div>
				</div>
				
			</div>
		</div>

		<div class="card shadow-sm">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">New Schema Object</h4>
			</div>
			<div class="card-body">
				<div id="editor"></div>
				<button class="btn btn-success mt-4" @click.prevent="createSchemaFromEditor"><i class="fas fa-star"></i> Create Schema</button>
			</div>
		</div>

	</div>

</template>

<script>

import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { toJsonDate } from '../util';
import _ from 'lodash';

import SchemaEditorField from "@/components/utilities/SchemaEditorField";
import SchemaDerivedField from "@/components/utilities/SchemaDerivedField";
import TreeNode from './utilities/TreeNode.vue';

const REGEX_SCHEMA_NAME_PART = /^[a-z_](-?[a-z0-9_]+)*$/;

export default {
	name: "project-schemas",
	props: [ 'nodeId', 'projectId', 'derivedSchema' ],
	components: {
		SchemaEditorField,
		SchemaDerivedField,
		TreeNode,
	},
	data() {
		return {
			doNotNavigateToNewSchema : false,
			newSchemaParent: "",
			newSchemaName: "",
			parentCompiledFields : [],
			overrideFields : { },
			standardFields : [ ],
			newSchema:
			{
				$schema : "$schema.$complete.",
				description : ""
			}
		};
	},
	watch:
	{
		derivedSchema( newValue, oldValue )
		{
			this.setDerivedSchema( newValue );
		},
		newSchemaParent: function( newValue, oldValue )
		{
			if( newValue != oldValue )
				this.updateParentCompiledFields( );
			this.$set( this.newSchema, '$id', this.getSchemaId( this.projectId, this.newSchemaName, newValue ) );
		},
		newSchemaName: function( newValue, oldValue )
		{
			this.$set( this.newSchema, '$id', this.getSchemaId( this.projectId, newValue, this.newSchemaParent ) );
		},
		newSchema:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				if( newValue.abstract === false )
					delete newValue.abstract;
				this.editor.setValue( JSON.stringify( newValue, null, 2 ), -1 );
			}
		},
		standardFields: {
			deep: true,
			handler: function( newVal, oldVal )
			{
				this.setJSONFields( newVal, this.overrideFields );
				this.editor.setValue( JSON.stringify( this.newSchema, null, 2 ), -1 );
			}
		},
		overrideFields: {
			deep: true,
			handler: function( newVal, oldVal )
			{
				this.setJSONFields( this.standardFields, newVal );
				this.editor.setValue( JSON.stringify( this.newSchema, null, 2 ), -1 );
			}
		},
		'newSchema.abstract': function( newVal, oldVal )
		{
			if( newVal !== true )
				this.$delete( this.newSchema, 'abstract' );
		}
	},
	computed:
	{
		schemasUrlPath( )
		{
			return '/nodes/'+ this.nodeId +'/projects/'+ this.projectId +'/schemas/';
		},
		schemaNameError: function( )
		{
			return this.newSchemaName && !REGEX_SCHEMA_NAME_PART.test( this.newSchemaName.toLowerCase( ) );
		},
		currentSessionAccount: function( )
		{
			try {
				let sessionGuid = this.activeSession( this.nodeId );
				let [ sNode, sKey ] = sessionGuid.split( "/" );
				let session = this.session( sessionGuid );
				let account = this.account( sNode, session.account );
				if( account )
					return account;
			} catch( err ) { }
			return { };	// No session.
		},
		...mapGetters( "accounts", {
			account: "account",
		}),
		...mapGetters( "authentication", {
			activeSession: "activeSession",
			session: "session"
		}),
		...mapGetters( "schemas", {
			schemas: "schemas", // map STATE schemas/schemas to "schemas" AS A FUNCTION, which requires the nodeId and projectId as inputs!
		}),
		...mapGetters( "collections", {
			collections: "collections",
		}),
		collectionList( ) {
			return this.collections( this.nodeId, this.projectId );
		},
		schemaList( )
		{
			return this.schemas( this.nodeId, this.projectId );
		},
		schemaLookup( )
		{
			const lookup = { };
			const schemas = this.schemaList || [];
			for( const s of this.schemaList )
			{
				const name = s.$id.split(':')[1];
				lookup[name] = s;
			}
			return lookup;
		}
	},
	methods:
	{
		setDerivedSchema( schemaName )
		{
			schemaName = ( schemaName || "" ).split( ':' ).pop( );
			this.newSchemaParent = schemaName;
			this.$refs.schemaNewName.focus( );
		},
		getSchemaNodeTree( schemas = null )
		{
			const path = this.schemasUrlPath;
			// return [
			// 	{ title: "auth", url: path + 'auth.', children: [ ] },
			// 	{ title: "action", url: path + 'action.', children: [
			// 		{ title: "accounts", url: path + 'accounts.', children: [
			// 			{ title: "create", url: path + 'create.', children: [ ] },
			// 			{ title: "edit", url: path + 'edit.', children: [ ] },
			// 		] },
			// 		{ title: "schemas", url: path + 'schemas.', children: [ ] },
			// 		{ title: "projects", url: path + 'projects.', children: [ ] }
			// 	] },
			// 	{ title: "permission", url: path + 'permission.', children: [ ] }
			// ];

			if( !Array.isArray( schemas ) )
			 	schemas = this.schemaList.sort( ( a, b ) => a.$id === b.$id ? 0 : ( a.$id > b.$id ? 1 : -1 ) );
			
			const nodes = [];
			for( let i=0; i < schemas.length; i++ )
			{
				const baseSchema = schemas[i];
				const baseName = baseSchema.$id.split(':').pop();
				const baseTitle = baseName.split('.').filter( part => part ).pop( );
				const descendents = [];
				for( let j=i+1; j < schemas.length; j++ )
				{
					const next = schemas[j];
					if( !next.$id.split(':').pop().startsWith( baseName ) )
						break;
					
					descendents.push( next );
					i=j;
				}
				nodes.push( {
					title: baseTitle,
					url: path + baseName,
					description: baseSchema.description,
					children: this.getSchemaNodeTree( descendents ),
					addChildFunction: ( ( node ) => {
						this.$router.push( { name: 'schemas', params: { nodeId: this.nodeId, projectId: this.projectId, derivedSchema: baseName } } );
						this.setDerivedSchema( baseName );
					} ).bind(this)
				} );
			}
			return nodes;
		},
		setJSONFields( standardFields, overrideFields )
		{
			this.$set( this.newSchema, 'fields', [] );
			const fields = this.newSchema.fields;
			for( let i=0; i < standardFields.length; i++ )
			{
				const field = _.cloneDeep( standardFields[i] );
				field.$schema = "$field.$standard.";
				this.$set( fields, fields.length, field );
			}
			for( let baseFieldId in overrideFields )
			{
				if( overrideFields[baseFieldId]._override !== true )
					continue;	// Skip non-committed fields.
				const field = _.cloneDeep( overrideFields[baseFieldId] );
				delete field._override;
				if( Object.keys( field ).length === 0 )
					continue;	// Skip fields with no override properties.
				field.overrides = baseFieldId;
				field.$schema = "$field.$override.";
				this.$set( fields, fields.length, field );
			}
		},
		async updateParentCompiledFields( )
		{
			const options = { compiled : true };
			const name = this.newSchemaParent;

			this.overrideFields = { };
			if( !name )
			{
				this.parentCompiledFields = [];
				return;
			}

			try {
				const compiledSchema = await this.readSchema( { nodeId : this.nodeId, projectId : this.projectId, name, nocache : true, options } );
				this.parentCompiledFields = compiledSchema.compiledfields;
				for( let i=0; i < this.parentCompiledFields.length; i++ )
				{
					const field = this.parentCompiledFields[i];
					if( !this.overrideFields[field.$id] )
						this.$set( this.overrideFields, field.$id, { _override : false } );
				}
			} catch( err ) {
				console.warn( `Could not retrieve the compiled schema [${name}]. Details:` );
				console.error( err );
				this.parentCompiledFields = [];
			}
		},
		getSchemaId( project, name, parent )
		{
			name = name.toLowerCase( );
			if( !project || !REGEX_SCHEMA_NAME_PART.test( name ) )
				return '';
			if( parent && !parent.endsWith( '.' ) )
				parent += '.';
			return project +':'+ parent + name +'.';
		},
		addSchemaField( )
		{
			const source = this.standardFields;
			this.$set( source, source.length, { name : "" } );
			const $vue = this;
			this.$nextTick( function( ) {
				try {
					const fields = $vue.$refs.schemaFields.children;
					for( let i=fields.length-1; i >= 0; i-- )
					{
						if( fields[i].tagName.toLowerCase( ) === 'div' )
						{
							fields[i].getElementsByTagName( "input" )[0].focus( );
							return;
						}
					}
				} catch( err ) { console.log( err ); }
			} );
		},
		deleteSchemaField( index )
		{
			this.newSchema.fields.splice( index, 1 );
		},
		...mapActions({
			readSchema: "schemas/read",
			listSchemas: "schemas/list",
			createSchema: "schemas/create",
			listCollections: "collections/list"
		}),
		async checkMySession( )
		{
			try {
				let sessionGuid = this.$store.getters['authentication/activeSession']( this.nodeId );
				return await this.$store.dispatch( 'authentication/checkSession', { nodeId : this.nodeId, sessionKey : sessionGuid } );
			} catch( err ) { console.error( err ); return null; }
		},
		async loadSchemas( nocache )
		{
			try {
				await this.listSchemas( { nodeId : this.nodeId, projectId : this.projectId, nocache : nocache } );
			} catch( err ) {
				if( err.response && ( err.response.status === 401 ) )
				{
					console.warn( "Session expired, invalid or missing.." );
					this.checkMySession( );
				}
				else
					throw err;
			}
		},
		async createSchemaFromData( )
		{
			// TODO: Set loading overlay
			await this.createNewSchema( this.newSchema );
		},
		async createSchemaFromEditor( )
		{
			// TODO: Set loading overlay
			let schema;

			try {
				schema = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Schema format issue:\n"+ err.message );
				console.error( err );
				return;
			}

			await this.createNewSchema( schema );
		},
		async createNewSchema( schema )
		{
			// UI Validation
			if( !schema.$id ) return alert( "Must define a schema name!" );
			
			try {
				let result = await this.createSchema( { nodeId : this.nodeId, projectId : this.projectId, newSchema : schema } );
				if( !result.$id )
					throw new Error( "Result from schema creation came back without an ID!" );
				if( this.doNotNavigateToNewSchema )
					return alert( "Schema successfully created." );
				
				let [ projectId, schemaName ] = result.$id.split( ":" );
				this.$router.push( { name : 'schema', params : { nodeId : this.nodeId, projectId, schemaName } } );
					
				// TODO: close loading overlay
			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Schema creation failed:", err );
				alert( "Schema creation failed!\n"+ err.message );
				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
			}
		},
		getAllSortedFields( o )
		{
			const allKeys = new Set();
			JSON.stringify( o, ( key, value ) => ( allKeys.add( key ), value ) );
			return Array.from( allKeys ).sort( );
			// return JSON.stringify( o, Array.from( allKeys ).sort(), space );
		},
		downloadSchemasData( formatted = false )
		{
			const filename = `schemas.${this.projectId}.${( new Date( ) ).toISOString( )}.json`
			const contentType = 'application/json';
			
			const skipFields = [ '$created', '$modified', '$version', '$node', 'owner' ];
			const fields = this.getAllSortedFields( this.schemaList ).filter( f => !skipFields.includes( f ) );
			const content = JSON.stringify( this.schemaList, fields, formatted ? '\t' : undefined );
			
			const a = document.createElement('a');
			const blob = new Blob([content], {'type':contentType});
			a.href = window.URL.createObjectURL(blob);
			a.download = filename;
			a.click();
		}
	},
	async created( )
	{
		await this.loadSchemas( true );	// Reload schemas in the background to make sure we have the latest.
	},
	async mounted( )
	{
		if( this.derivedSchema )
			this.setDerivedSchema( this.derivedSchema );
		try {
			this.editor = ace.edit( "editor", {
				mode: "ace/mode/json",
				theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
				maxLines: 20,
				minLines: 5,
				fontSize: 14,
				showPrintMargin : false
			});
			this.editor.setValue( JSON.stringify( this.newSchema, null, 2 ), -1 );
			await this.listCollections( { nodeId : this.nodeId, projectId : this.projectId } );
		} catch( err ) { throw err; }
	}
};
</script>
<style scoped>
div#editor
{
	border: 1px solid #666;
}
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/Schemas.vue